"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Heading = _interopRequireDefault(require("../Heading/Heading"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalHeaderTitle = function ModalHeaderTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle"]);

  return (0, _themeUi.jsx)(_themeUi.Box, props, (0, _themeUi.jsx)(_Heading["default"], {
    as: "h1",
    variant: "heading5",
    sx: {
      color: 'primary'
    }
  }, title), subtitle && (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      color: 'textMediumEmphasis'
    }
  }, subtitle));
};

ModalHeaderTitle.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string
};
var _default = ModalHeaderTitle;
exports["default"] = _default;